import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { OfferCard } from "@/components/Cards";

export default function Offers() {
  const [offers, setOffers] = useState([]);
  useEffect(() => { api.get("/offers").then((r) => setOffers(r.data)); }, []);
  return (
    <div>
      <Seo title="Offers & Deals" description="Exclusive deals and offers from RiNo Art District businesses — happy hours, discounts, and freebies across Denver's River North." />
      <PageHeader overline="Save in RiNo" title="Offers & Deals" subtitle="Exclusive discounts and freebies from your favorite RiNo breweries, cafes, galleries, and shops." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="offers-list">
          {offers.map((o, i) => <OfferCard key={o.id} o={o} index={i} />)}
        </div>
      </div>
    </div>
  );
}
